import { render, staticRenderFns } from "./AcompanharEnvio.vue?vue&type=template&id=00f180cc"
import script from "./AcompanharEnvio.vue?vue&type=script&lang=js"
export * from "./AcompanharEnvio.vue?vue&type=script&lang=js"
import style0 from "./AcompanharEnvio.vue?vue&type=style&index=0&id=00f180cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VIcon})
